/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomaticInvestigationCompletedSuccessfullyRequestDto
 */
export interface AutomaticInvestigationCompletedSuccessfullyRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof AutomaticInvestigationCompletedSuccessfullyRequestDto
     */
    workflowInstanceId: string;
    /**
     * Numeric metric of the solution
     * @type {number}
     * @memberof AutomaticInvestigationCompletedSuccessfullyRequestDto
     */
    score: number;
    /**
     * Human-readable report of automated operation
     * @type {string}
     * @memberof AutomaticInvestigationCompletedSuccessfullyRequestDto
     */
    report: string;
}

/**
 * Check if a given object implements the AutomaticInvestigationCompletedSuccessfullyRequestDto interface.
 */
export function instanceOfAutomaticInvestigationCompletedSuccessfullyRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('score' in value)) return false;
    if (!('report' in value)) return false;
    return true;
}

export function AutomaticInvestigationCompletedSuccessfullyRequestDtoFromJSON(json: any): AutomaticInvestigationCompletedSuccessfullyRequestDto {
    return AutomaticInvestigationCompletedSuccessfullyRequestDtoFromJSONTyped(json, false);
}

export function AutomaticInvestigationCompletedSuccessfullyRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomaticInvestigationCompletedSuccessfullyRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'score': json['score'],
        'report': json['report'],
    };
}

export function AutomaticInvestigationCompletedSuccessfullyRequestDtoToJSON(value?: AutomaticInvestigationCompletedSuccessfullyRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'score': value['score'],
        'report': value['report'],
    };
}

